

import React, { useState, useEffect } from "react";

const AREAS = [
  "Nutrition",
  "Fitness",
  "Mindfulness",
  "Holistic Health",
  "Life Coaching",
  "Other"
];

export default function KinosLeadModal({ open, onClose, email }) {
  const [area, setArea] = useState("");
  const [instagram, setInstagram] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [modalEmail, setModalEmail] = useState(email || "");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    setModalEmail(email || "");
  }, [email]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      // const response = await fetch('http://localhost:3001/api/subscribe', {
        const response = await fetch('https://kinos-api.onrender.com/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: modalEmail,
          firstName: firstName,
          social: instagram, // Added Instagram handle
          area: area, // Added area of expertise
          source: 'Calendly Landing Page',
          tags: ['Calendly Interest', 'Book Demo']
        }),
      });

      const result = await response.json();
      
      if (result.success) {
        window.open("https://calendly.com/usekinos", "_blank");
        setSubmitted(true);
        setMessage('Thanks for subscribing! Opening calendar...');
      } else {
        window.open("https://calendly.com/usekinos", "_blank");
        setSubmitted(true);
        console.warn('Mailchimp subscription failed:', result.error);
      }
    } catch (error) {
      console.error('Error adding to Mailchimp:', error);
      window.open("https://calendly.com/usekinos", "_blank");
      setSubmitted(true);
      setMessage('Calendar opened! (Note: subscription may have failed)');
    }

    setLoading(false);
  };

  const handleAreaSelect = (selectedArea) => {
    setArea(selectedArea);
    setDropdownOpen(false);
  };

  const handleFormSubmit = () => {
    // Validate required fields
    if (!modalEmail || !area || !instagram || !firstName) {
      alert("Please fill in all required fields");
      return;
    }
    
    // Call the original handleSubmit function
    const fakeEvent = { preventDefault: () => {} };
    handleSubmit(fakeEvent);
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 md:flex md:items-center md:justify-center">
      <div className="bg-white w-full h-full md:rounded-2xl md:shadow-2xl md:max-w-5xl md:min-h-[700px] md:w-full md:h-auto p-0 relative md:border md:border-[#c4ffa0] overflow-hidden flex flex-col md:flex-row">
        {/* Close button */}
        <button
          className="absolute top-6 right-6 text-[#2d4a1e] hover:text-[#1a2d11] text-4xl z-20 bg-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition duration-200 hover:rotate-90 border border-[#c4ffa0]/30"
          onClick={onClose}
        >
          &times;
        </button>

        {/* Left Side (hidden on mobile) */}
        <div className="hidden md:flex md:w-1/2 flex-col items-center justify-center bg-[#c4ffa0]/10 p-8 md:p-10">
          <img
            src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80"
            alt="KinOS Visual"
            className="rounded-xl w-32 h-32 md:w-40 md:h-40 object-cover mb-4 shadow"
          />
          <span className="text-[#2d4a1e] font-bold text-xl mb-1">KinOS</span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#2d4a1e] mb-2 text-center">
            Let's Get You Started!
          </h2>
        </div>

        {/* Right Side */}
        <div className="w-full md:w-1/2 bg-white p-4 md:p-10 flex flex-col justify-start min-h-full">
          {/* Mobile-only header */}
          <div className="block md:hidden mb-6 text-center pt-12">
            <span className="text-[#2d4a1e] font-bold text-xl">KinOS</span>
            <h2 className="text-2xl font-extrabold text-[#2d4a1e] mt-2">
              Let's Get You Started!
            </h2>
          </div>

          {submitted ? (
            <div className="text-center text-[#2d4a1e] font-semibold text-lg flex-1 flex items-center justify-center min-h-[200px]">
              Thank you! We'll be in touch soon.
            </div>
          ) : (
            <div className="flex flex-col gap-4 md:gap-8 px-1 md:px-0 pb-8 md:pb-12 flex-1">
              <div>
                <label className="block text-[#2d4a1e] font-semibold mb-2 text-base md:text-lg">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  className="w-full px-4 py-3 md:px-5 md:py-4 bg-[#c4ffa0]/10 border border-[#c4ffa0] md:border-2 rounded-lg md:rounded-xl text-base md:text-lg text-[#2d4a1e] placeholder:text-[#2d4a1e]/60 focus:outline-none focus:ring-2 focus:ring-[#c4ffa0] focus:border-[#c4ffa0] transition"
                />
              </div>

              <div>
                <label className="block text-[#2d4a1e] font-semibold mb-2 text-base md:text-lg">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={modalEmail}
                  onChange={(e) => setModalEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 md:px-5 md:py-4 bg-[#c4ffa0]/10 border border-[#c4ffa0] md:border-2 rounded-lg md:rounded-xl text-base md:text-lg text-[#2d4a1e] placeholder:text-[#2d4a1e]/60 focus:outline-none focus:ring-2 focus:ring-[#c4ffa0] focus:border-[#c4ffa0] transition"
                />
              </div>

              <div className="relative">
                <label className="block text-[#2d4a1e] font-semibold mb-2 text-base md:text-lg">
                  Area of Expertise <span className="text-red-500">*</span>
                </label>
                <button
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="w-full px-4 py-3 md:px-5 md:py-4 bg-[#c4ffa0]/10 border border-[#c4ffa0] md:border-2 rounded-lg md:rounded-xl text-base md:text-lg text-[#2d4a1e] focus:outline-none focus:ring-2 focus:ring-[#c4ffa0] focus:border-[#c4ffa0] transition text-left flex justify-between items-center"
                >
                  <span className={area ? "text-[#2d4a1e]" : "text-[#2d4a1e]/60"}>
                    {area || "Select an area"}
                  </span>
                  <svg
                    className={`w-5 h-5 md:w-6 md:h-6 text-[#2d4a1e] transition-transform duration-200 ${
                      dropdownOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {dropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 md:mt-2 bg-white border border-[#c4ffa0] md:border-2 rounded-lg md:rounded-xl shadow-lg md:shadow-xl max-h-60 overflow-auto">
                    {AREAS.map((areaOption) => (
                      <button
                        key={areaOption}
                        type="button"
                        onClick={() => handleAreaSelect(areaOption)}
                        className="w-full px-4 py-3 md:px-5 md:py-4 text-left text-base md:text-lg text-[#2d4a1e] hover:bg-[#c4ffa0]/10 focus:bg-[#c4ffa0]/10 focus:outline-none transition-colors border-b border-[#c4ffa0]/20 last:border-b-0"
                      >
                        {areaOption}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div>
                <label className="block text-[#2d4a1e] font-semibold mb-2 text-base md:text-lg">
                  Social Handle <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="@yourhandle"
                  className="w-full px-4 py-3 md:px-5 md:py-4 bg-[#c4ffa0]/10 border border-[#c4ffa0] md:border-2 rounded-lg md:rounded-xl text-base md:text-lg text-[#2d4a1e] placeholder:text-[#2d4a1e]/60 focus:outline-none focus:ring-2 focus:ring-[#c4ffa0] focus:border-[#c4ffa0] transition"
                  value={instagram}
                  onChange={(e) => setInstagram(e.target.value)}
                  required
                />
              </div>

              <button
                type="button"
                onClick={handleFormSubmit}
                disabled={loading}
                className="w-full px-5 py-3 md:px-6 md:py-4 bg-[#c4ffa0] text-[#2d4a1e] text-sm md:text-lg font-semibold md:font-bold rounded-lg md:rounded-xl hover:shadow-lg md:hover:shadow-xl transition duration-300 hover:bg-[#b3ee90] flex justify-center items-center mt-2 md:mt-4 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Getting Started...' : 'Get Started'}
              </button>

              <div className="text-xs md:text-sm text-gray-500 mt-2 md:mt-4 text-center leading-relaxed">
                We respect your privacy. Your info will only be used to follow up about KinOS.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}